import I18N from '@leverege/i18n';
import { Attributes } from '@leverege/ui-attributes';
const i18n = I18N.ns('openApi.blueprint.SaleJobService.saleJob.attributes.failedSteps');
export default {
  name: 'failedSteps',
  path: 'failedSteps',
  objectType: 'SaleJobService.saleJob',
  valueType: 'string',
  get displayName() {
    return i18n.t('name', 'Failed Steps', {
      count: 1
    });
  },
  source: {
    type: 'SaleJobService',
    model: {},
    creatable: false,
    editable: false,
    sortable: false,
    filterable: false
  },
  get: (data, cxt) => {
    const state = Attributes.get('state', 'SaleJobService.saleJob', data, cxt);
    const failedSteps = [];
    Object.entries(state || {}).forEach(([key, val]) => {
      if (val?.success === false) {
        failedSteps.push(key);
      }
    });
    return failedSteps.join(', ');
  },
  canSet: () => false,
  getString: () => null,
  getDescription: () => null,
  getOption: optionName => {
    return null;
  }
};